// extracted by mini-css-extract-plugin
export default {"carouselContainer":"CarouselSlider_carouselContainer__t8aND","carouselSlider":"CarouselSlider_carouselSlider__FeqB-","carouselItem":"CarouselSlider_carouselItem__JFDtZ"};